import { AxiosInstance, AxiosResponse } from "axios";

/**
 * Événement global émis quand la session ne peut plus être rafraîchie.
 * AuthContext l'écoute pour se logout proprement.
 */
export const AUTH_SESSION_EXPIRED_EVENT = "auth:session-expired";

class RefreshManager {
    /**
     * Promise du refresh en cours (single-flight).
     */
    private refreshPromise: Promise<AxiosResponse> | null = null;

    /**
     * Compteur d'échecs consécutifs.
     */
    private failureCount = 0;

    private readonly MAX_FAILURES = 3;

    /**
     * SINGLE FLIGHT
     */
    public refresh(client: AxiosInstance): Promise<AxiosResponse> {
        if (this.refreshPromise) {
            return this.refreshPromise;
        }

        this.refreshPromise = this.execute(client)
            .then((response) => {
                this.failureCount = 0;
                return response;
            })
            .catch((error) => {
                this.failureCount += 1;

                console.warn(
                    `[RefreshManager] Refresh failed (${this.failureCount}/${this.MAX_FAILURES})`,
                    error?.response?.status,
                );

                if (this.failureCount >= this.MAX_FAILURES) {
                    this.emitSessionExpired();
                }

                throw error;
            })
            .finally(() => {
                this.refreshPromise = null;
            });

        return this.refreshPromise;
    }

    private execute(client: AxiosInstance): Promise<AxiosResponse> {
        return client.post("/auth/refresh");
    }

    public forceExpired(): void {
        this.emitSessionExpired();
    }

    public reset(): void {
        this.refreshPromise = null;
        this.failureCount = 0;
    }

    private emitSessionExpired(): void {
        if (typeof window !== "undefined") {
            window.dispatchEvent(
                new CustomEvent(AUTH_SESSION_EXPIRED_EVENT),
            );
        }
    }
}

export const refreshManager = new RefreshManager();